<template>
  <div>
    <VueUeditorWrap
      v-model="content"
      :config="myConfig"
      @beforeInit="addCustomButtom"
    ></VueUeditorWrap>
    <el-dialog
      title="图片上传"
      :visible.sync="dialogVisible"
      width="300px"
      :lock-scroll="true"
      :close-on-click-modal="false"
    >
      <div class="image-upload-panel">
        <!--<div class="image-item"
             v-for="(item,index) in imageList"
             :key="index">
          <img :src="item.url">
          <span class="image-del el-icon-close"
                @click="delImage(index)"></span>
        </div>-->

        <!-- <el-upload
          class="image-upload-btn"
          :action="uploadUrl"
          list-type="picture-card"
          name="upfile"
          accept=".png,.PNG,.jpg,.JPG,.jpeg"
          :http-request="uploadFile"
          :show-file-list="false"
          :auto-upload="true"
        > -->
        <el-upload
            class="image-upload-btn"
            list-type="picture-card"
            action
            :multiple="false"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onChangeImg"
            :disabled="uploadFlag"
          >
          <div slot="tip" style="width:100%;font-size:12px;">只能上传jpg/png文件，且不超过2MB</div>
          <img v-if="image.url&&!uploadFlag" :src="image.url" class="upload-image" />
          <i v-else-if="!image.url&&!uploadFlag" class="el-icon-plus avatar-uploader-icon"></i>
          <el-progress v-if="uploadFlag" type="circle" :width="60" :percentage="uploadPercentage" style="margin-left:28%;margin-top:25%;z-index:100"></el-progress>
        </el-upload>
        <div>
          <span style="fontweight: bold">宽度:</span>
          <div style="display: inline-block; width: 180px; margin-top: 5px">
            <el-input
              v-model="image.width"
              size="small"
              placeholder="输入宽度,如:100,50%"
            ></el-input>
          </div>
        </div>
        <div>
          <span style="fontweight: bold">高度:</span>
          <div style="display: inline-block; width: 180px; margin-top: 5px">
            <el-input
              v-model="image.height"
              size="small"
              placeholder="输入高度,如:100,50%"
            ></el-input>
          </div>
        </div>
        <el-button class="upload_btn" type="primary"  @click="uploadImg" :disabled="img_file===''">上传</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            () => {
              this.dialogVisible = false;
            }
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="insertImage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import {getOSSAuth_Api} from '../../apis/oss.api';
let loading;
export default {
  components: {
    VueUeditorWrap,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uploadFlag:false,
      uploadPercentage:0,
      uploadUrl: "",
      loading: undefined,
      img_file:'',
      image: {
        url: null,
        width: null,
        height: null,
      },
      dialogVisible: false,
      editorHandler: null,
      content: this.value,
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 540,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！部署在国外的服务器，如果无法访问，请自备梯子）
        serverUrl: "",
        allowDivTransToP: false,
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/static/UEditor/",
      },
    };
  },
  methods: {
    onChangeImg(file){
      console.log("img",file);
      const isJPG = file.raw.type === "image/jpeg";
      const isJPG2 = file.raw.type === "image/jpg";
      const isPNG = file.raw.type === "image/png";
      const isLimit2 = file.raw.size / 1024 / 1024 < 2;
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$global.error(this,"只能上传jpg或png格式的图片！",null);
      }
      else if (!isLimit2) {
        this.$global.error(this,"只能上传2MB以内的图片！",null);
      }
      if((isJPG || isJPG2 || isPNG) && isLimit2){
        this.image.url=URL.createObjectURL(file.raw);
        this.img_file=file.raw;
      }
      
    },
    async uploadImg(){
      if(!this.image.url||!this.img_file){
        this.$global.error(this,"请选择图片！",null);
        return;
      }
      this.uploadFlag=true;
      let result=await getOSSAuth_Api();
      let str=this.img_file.name.split('.');
      const that = this;
      console.log("au",result);
      if(result){
        let file_name=result.base_path+str[0]+Date.parse(new Date())+'.'+str[1];
        result.oss.multipartUpload(file_name,this.img_file,{
            progress: function(p) {
              //p进度条的值
              //console.log(p);
              that.uploadPercentage=Math.floor(p * 100);
            }
          }
        ).then(res=>{
          this.uploadFlag=false;
          console.log("result",res);
          this.$global.success(this,"图片上传成功！",null);
          this.image.url=res.res.requestUrls[0].split('?')[0];
        }).catch(err=>{
          this.uploadFlag=false;
          this.$global.error(this,"图片上传失败！",null);
        })
      }
      else{
        this.$global.error(this,"服务器错误！",null);
        this.uploadFlag=false;
      }
    },
    // async uploadFile(params) {
    //   this.$global.uploadFile(this, params).then((res) => {
    //     this.image.url = res.split("?")[0];
    //   });
    // },
    insertImage() {
      if (this.image.url) {
        this.editorHandler.execCommand("insertimage", {
          src: this.image.url,
          width: this.image.width ? this.image.width : null,
          height: this.image.height ? this.image.height : null,
        });
      }
      this.dialogVisible = false;
    },
    addCustomButtom(editorId) {
      let that = this;
      window.UE.registerUI("dialog", function (editor, uiName) {
        that.editorHandler = editor;
        var btn = new UE.ui.Button({
          name: "file-upload",
          title: "图片上传",
          cssRules: `background-image: url('http://58.33.91.82:12404/wupen-test/images/news/upload.jpeg') !important;background-size: cover;`,
          onclick: function () {
            that.dialogVisible = true;
            editor.execCommand(uiName);
          },
        });
        return btn;
      });
    },
  },
  watch: {
    value(newValue) {
      this.content = newValue;
    },
    content(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>
<style lang="scss" scoped>
.edui-editor{
  z-index: 3099 !important;
}
.image-upload-panel {
  overflow: hidden;
  text-align: center;
  width: 100%;
  .upload_btn{
    margin-top:10px;
  }
  /deep/ .el-progress__text{
    margin-left: -28%;
  }
  /deep/ .el-progress-circle{
    text-align: center;
  }
}

.image-upload-btn div {
  width: 150px;
}

.image-upload-btn i {
  font-size: 30px;
  font-weight: 400;
}
.upload-image {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  text-align: center;
}
/deep/ .el-dialog__wrapper {
  z-index: 3000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/template/Ueditor.vue